import React, { Component } from 'react';
import { connect } from 'react-redux';
import Partner from '../Partner';
import {
  clickPartnerAnalytics,
  fetchBio,
  fetchEpisodeCount,
  fetchFollowerCount,
  fetchTotalPlayCount,
} from '../../partnerAnalytics';
import { setIsCreating } from '../../episodes';

const mapDispatchToProps = dispatch => ({
  actions: {
    cancelCreateEpisode: () => dispatch(setIsCreating(false)),
    clickPartnerAnalytics: target => dispatch(clickPartnerAnalytics(target)),
    createEpisode: () => dispatch(setIsCreating(true)),
    fetchBio: () => dispatch(fetchBio()),
    fetchEpisodeCount: () => dispatch(fetchEpisodeCount()),
    fetchFollowerCount: () => dispatch(fetchFollowerCount()),
    fetchTotalPlayCount: () => dispatch(fetchTotalPlayCount()),
  },
});

const mapStateToProps = ({
  partnerAnalytics,
  episodes,
  user: { user, permissions },
}) => ({
  ...partnerAnalytics,
  user,
  permissions,
  ...episodes,
});

class PartnerContainer extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchBio();
    actions.fetchEpisodeCount();
    actions.fetchFollowerCount();
    actions.fetchTotalPlayCount();
  }

  render() {
    return <Partner {...this.props} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerContainer);
